<dex-tranche-details-standalone
    [tranche]="tranche()"
    [isEmbedded]="true"
    [isCollapsed]="isCollapsed()"
    [isExpandCollapseEnabled]="isExpandCollapseEnabled()"
    [isSymbolClickable]="isSymbolClickable()"
    (toggleCollapsed)="toggleCollapsed.emit()"
    (symbolClick)="symbolClick.emit($event)"
    (tradeClick)="tradeClick.emit($event)">
</dex-tranche-details-standalone>
